<template>
  <custom-field-input-base-old
    single-line
    :field="field"
    v-model="value"
    type="number"></custom-field-input-base-old>
</template>

<script>
import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';

export default {
  name: 'custom-field-number-old',
  mixins: [customFieldTypeMixinOld],

  data() {
    return {
      value: String(this.field.value) // Cast to string to prevent "0" as default in field
    };
  },
  watch: {
    value() {
      if (this.value === '') {
        this.$emit('update:model-value', '');
        return;
      }
      this.$emit('update:model-value', Number(this.value));
    }
  }
};
</script>
